import * as React from 'react';
import * as queryString from 'query-string'
import httpService from '../../service/httpService';
export interface IDashboardLoadData {
    hasKey?: boolean;
    keyEncrypted?: string
    data?: any;
}

export interface IDashboardSearchSection {
    param: string
    url?: string
    preload?: boolean
    onLoad(data?: IDashboardLoadData): void
}

interface IDashboardLayout {
    name?: string;
    URLParams?: IDashboardSearchSection[],
    loadingStart?(): void;
    loadingStop?(): void;
}



type combinedProps =  IDashboardLayout;

export class SystemDashboardLayout extends React.Component<combinedProps, any, any> {    

    constructor(props: any) {
        super(props);
    }
    state = {
        isLoading: false,
        node: null,
    }
    componentDidMount = () => {

        this.props.URLParams && this.props.URLParams.forEach((setting: IDashboardSearchSection) => this.getDetails(setting))
    }



    getDetails = async (setting: IDashboardSearchSection): Promise<any> => {
        
        this.setState({ isLoading: true });
        var param = queryString.parse(location.search);
        var data: IDashboardLoadData = {};
        
        if (param && param[setting.param]) {
            data.hasKey = true;
            data.keyEncrypted = param[setting.param] as string;
            data.data = null;

            if (setting.preload == true) {
                try {
                    const resp = await httpService.get(setting.url + data.keyEncrypted);
                    data.data = resp.data
                    this.setState({ isLoading: false });
                } catch (e) {
                    this.setState({ isLoading: false });
                }
            }

            setting.onLoad && setting.onLoad(data)
            this.setState({ isLoading: false });
            return setting;
        }
        this.setState({ isLoading: false });
        return null;
    }


    render() {
        return (<>
            <div className="container-fluid mt-80">
                <section className="tile-wrapper">
                    <div className="container-fluid containerpadding">
                        {this.props.children}
                    </div>
                </section>
            </div>
        </>
        )
    }
}

